import 'rc-tooltip/assets/bootstrap.css';
import 'rc-slider/assets/index.css';
import './App.css';
import React from 'react'
import _ from 'lodash';
import $ from 'jquery';
import KeywordInput from './keyword-input'
import KeywordExamples from './keyword-examples'
import MiniNav from './mininav'
import Switch from "react-switch";
import netlifyIdentity from 'netlify-identity-widget';
import TextLoader from './text-loader'

import testData from './test-data'

class App extends React.Component{

    constructor(props){
      super(props);

      this.state = {
        keyword: '',
        submittedKeyword: '',
        taskId: null,
        response: null,
        error: '',
        isLoading: false,
        currentUser: null,
        showSignupWall: false,
        showNoPAABox: false,
        currentUser:null
      }
    
      this.handleCalculate = this.handleCalculate.bind(this);
      this.pollUntilQuestionsReturned = this.pollUntilQuestionsReturned.bind(this);
      this.animateQuestions = this.animateQuestions.bind(this);
      this.signIn = this.signIn.bind(this);
      this.signUp = this.signUp.bind(this);
      this.exportToCSV = this.exportToCSV.bind(this);

      this.useTestData = false;
      // this.rootUrl = 'http://localhost:3000';
      this.rootUrl = 'https://app.usetopic.com';
    }

    componentDidMount(){
      var that = this;
      if(this.useTestData && testData && _.isObject(testData)){
        this.setState({
          response: testData,
          isLoading: false,
          error: '',
          keyword: "test",
          submittedKeyword: "test"
        });
      }

      netlifyIdentity.on('init', (user) => {
        that.setState({
          currentUser: user,
          showSignupWall: false
        });
      });
      netlifyIdentity.on('login', (user) => {
        that.setState({
          currentUser: user,
          showSignupWall: false
        });
        netlifyIdentity.refresh().then((jwt)=>{
          console.log('JWT', jwt)
          if(window.location.href.indexOf('people-also-ask.netlify.app') !== -1){
            window.location.href = `https://www.usetopic.com/people-also-ask#access_token=${jwt}`;
          }
        });
      });
      netlifyIdentity.on('logout', () => {
        that.setState({
          showSignupWall: true,
          currentUser: null
        });
      });

      netlifyIdentity.on('close', () => {
        window.location.reload();
      });

      netlifyIdentity.init({
        APIUrl: 'https://people-also-ask.netlify.app/.netlify/identity'
      });
    }

    componentDidUpdate(){
      if($('.paa-title').length > 0 && $('.paa-title.triggered').length === 0){
        this.animateQuestions();
      }
    }

    componentWillUnmount(){
      netlifyIdentity.off('init');
      netlifyIdentity.off('login');
      netlifyIdentity.off('logout');
    }

    animateQuestions(){
      $('.paa-title').each(function(index){
        $(this).addClass('triggered delay-1'+index);
      });
      $('.paa-col').each(function(index){
        var boxDelay = index+1;
        $(this).find('.paa-box').each(function(index){
          $(this).addClass('delay-'+boxDelay+'0');
          $(this).find('.paa-subsubtitle').each(function(index){
            $(this).addClass('delay-'+boxDelay+(index+1));
          });
        });      
      });
      window.setTimeout(function(){
        $('.paa-title').addClass('active');
      }, 100);
      window.setTimeout(function(){
        $('.paa-box').addClass('active');
        $('.paa-subsubtitle').addClass('active');
      }, 1000);
    }

    handleCalculate(e){
      var that = this;
      var {keyword, isLoading, currentUser} = this.state;

      // comment this out if you want to disable forced-signup
      if(currentUser === null){
        this.setState({
          showSignupWall: true
        });
        return;
      }

      if(_.isString(e)){
        keyword = e; // called from keyword-examples
        that.setState({keyword: keyword});
      } else{
        e.preventDefault();
      }
      
      if(isLoading){
        alert('Please wait while we fetch the questions for your keyword. This may take a minute.');
        return;
      } else if(keyword.trim().length === 0){
        alert('Please enter a valid keyword.');
        return;
      }
      this.setState({
        isLoading: true,
        showNoPAABox: false,
        submittedKeyword: keyword
      })

      async function postData(url = '', data = {}) {
        // Default options are marked with *
        const response = await fetch(url, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data) // body data type must match "Content-Type" header
        });
        return response.json(); // parses JSON response into native JavaScript objects
      }

      if(this.useTestData){
        that.setState({
          taskId: testData.success.id,
          error: '',
          submittedKeyword: testData.success.keyword
        });
        that.pollUntilQuestionsReturned(testData.success.id, testData.success.keyword);
      } else{
        postData(`${that.rootUrl}/api/questions`, {
          keyword: keyword,
          ip: `${_.random(10000000000)}`
        })
          .then(data => {
            console.log(data);
            if(data.success){
              var taskId = data.success;
              that.setState({
                taskId: data.success,
                error: '',
                submittedKeyword: keyword
              });
              that.pollUntilQuestionsReturned(taskId, keyword);
            } else if(data.error){
              that.setState({
                error: data.error,
                isLoading: false
              })
            } else{
              that.setState({
                error: 'Something went wrong getting the recommendation. Please contact support@usetopic.com',
                isLoading: false
              })
            }
          });
      }
    }

    signIn(){
      netlifyIdentity.open('login');
    }

    signUp(){
      netlifyIdentity.open('signup');
    }

    pollUntilQuestionsReturned(){
      var that = this;
      var pollIntervalTime = 5000;
      var {taskId, submittedKeyword} = this.state;
      if(window.questionInterval){
        window.clearInterval(window.questionInterval);
      }

      if(this.useTestData){
        that.setState({
          response: testData.success.response,
          isLoading: false
        })
      } else{
        window.questionInterval = window.setInterval(() => {
          fetch(`${that.rootUrl}/api/questions/${taskId}`)
            .then(response => response.json())
            .then((data) => {
              console.log(data);
              if(data.success){
                var status = data.success.status;
                if(status === 'pending'){
                  // do nothing
                } else if(status === 'success'){
                  var response = data.success.response;
                  if(_.isObject(response) && response.error && /Daily limit exceeded/.test(response.error)){
                    that.setState({
                      error: 'Daily limit exceeded',
                      showNoPAABox: false,
                      isLoading: false
                    })
                    return;
                  } else if(_.isObject(response.questions)){
                    that.setState({
                      response: response,
                      showNoPAABox: false,
                      isLoading: false
                    })
                  } else if(_.isString(response.questions)){
                    that.setState({
                      showNoPAABox: true,
                      isLoading: false
                    })
                  } else{
                    that.setState({
                      error: 'Something went wrong getting the questions. Please email support@usetopic.com',
                      showNoPAABox: false,
                      isLoading: false
                    })
                  }
                  window.clearInterval(window.questionInterval);
                }
              } else{
                that.setState({
                  error: 'Something went wrong getting the questions. Please email support@usetopic.com',
                  isLoading: false
                })
                window.clearInterval(window.questionInterval);
              }
            });
        }, pollIntervalTime);
      }
    }

    exportToCSV(){
      var {submittedKeyword, response} = this.state;
      var filename = `questions for ${submittedKeyword}.csv`
      if(response && response.questions){

        // turn tree data into array data
        var data = [];
        function traverse(tree, index){
          if(tree.query){
            if(!_.isEmpty(tree.children) && index !== 0){
              data.push([" "]);
            }
            if(index !== null){
              data.push([tree.query]);
            }
          }

          if(_.isEmpty(tree.children)){
            return true;  
          } else{
            _.each(tree.children, (child, index) => {
              traverse(child, index);
            })
          }
        }
        traverse(response.questions, null);

        let prefix = "data:text/csv;charset=utf-8,";
        let csvContent =  data.map(e => e.join(",")).join("\n");

        var encodedUri = prefix + encodeURIComponent(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
      }
    }

    render(){
      var that = this;
      var {keyword, isLoading, error, response, submittedKeyword, currentUser, showSignupWall, showNoPAABox} = this.state;
      var questions = response && response.questions;
      var showResults = !isLoading && !_.isEmpty(response) && response.questions;

      console.log(questions);

      return (

        <div className="App">
          {!showSignupWall && <React.Fragment>

          <MiniNav currentUser={currentUser} onLogout={() => { netlifyIdentity.logout(); }} onExportCSV={this.exportToCSV} showExportCSV={!!(response && response.questions)} />
          <KeywordInput keyword={keyword} onClick={this.handleCalculate} onChange={(e) => {that.setState({keyword: e.target.value});}} isLoading={isLoading} />
          <KeywordExamples onClick={(keyword) => { this.handleCalculate(keyword); }} />
          {error && <div className="error" style={{color: 'red', textAlign: 'center'}}>{error}</div>}

          <div className="downtime-alert">
            <div className="downtime-alert-text">
              We are disabling this tool for a period extended maintenance. For a free alternative, check out <a href="https://searchresponse.io/people-also-ask" target="_blank">SearchResponse's People Also Ask tool</a>.
            </div>
          </div>

          </React.Fragment>}

          {showSignupWall && <div style={{textAlign: 'center', paddingBottom: '200px'}}>
            <div>
              Almost there! Create a free account to get access to: 
              <div style={{marginTop: '10px'}}><i className="fas fa-check" /> unlimited question searches</div>
              <div><i className="fas fa-check" /> export questions to CSV</div>
              <div><i className="fas fa-check" /> additional free tools</div>
            </div>
            <button onClick={this.signUp} className="pushable" style={{marginTop: '30px', marginBottom: '10px'}}>
              <span className="pushable-shadow"></span>
              <span className="pushable-edge"></span>
              <span className="pushable-front">
                Create Free Account
              </span>
            </button>
            <br />
            or <a href="#" onClick={this.signIn}>log in</a>
          </div>}

          {
            isLoading && <TextLoader
            animationIntervalSpeed={7000}
            lines={[
              'Question extraction may take up to 1 minute',
              'Queuing question extraction job',
              `Searching Google for "${submittedKeyword}"`,
              'Extracting questions from People Also Ask box',
              'Searching for related questions',
              'Extracting related questions',
              'Identifying semantic clusters',
              'Clustering questions into semantically related groups',
              'Identifying largest clusters',
              'Filtering out irrelevant questions',
              'Optimizing data structure',
              'Formatting data'
            ]} />
          }

          {showNoPAABox && <div style={{textAlign:'center', paddingTop: '70px', paddingBottom: '180px'}}>
            <h4 style={{color:'white'}}>We didn't find a "People Also Ask" box for this keyword.</h4>
            <p style={{color:'#a8bde2'}}>Try searching for a different keyword. 88.9% of searches include this feature, so keep trying!</p>
          </div>}

          {showResults && <React.Fragment>

            <h2 style={{color:'white',textAlign:'center',marginTop:'60px'}}>
              Top Questions Asked About {submittedKeyword}</h2>
              <div className="row paa-output-results">
                {_.map(questions.children, (question, index1) => {
                  return (
                  <div key={index1} className="col-sm paa-col">
                    <div className="paa-title">{question.query}</div>
                    <div>
                    {_.map(question.children, (question, index2) => {
                      return (
                      <div key={`${index1}${index2}`} className="paa-box">
                        <div className="paa-subtitle">{question.query}</div>
                        {_.map(question.children, (question, index3) => {
                          return (
                          <div key={`${index1}${index2}${index3}`} className="paa-subsubtitle">{question.query}</div>
                        )})}
                      </div>
                    )})}
                    </div>
                  </div>
                )})}
              </div>

          </React.Fragment>}
        </div>
      );
    }

}

export default App